<table style="display: block;" class="table box-body-table" *ngIf="data?.length">
  <thead>
  <tr>
    <th>{{ 'COMMON.progress' | translate }}</th>
    <th>{{ 'COMMON.payrolls' | translate }}</th>
  </tr>
  </thead>
  <tbody>
  <tr *ngFor="let serie of data | sort:'name'">
    <td class="half-width">
      <!-- progress -->
      <div class="progress">
        <div class="info" [style.width]="serie.value + '%'">
          <p class="small text-center">{{serie.value}}%</p>
        </div>
      </div>
    </td>
    <td class="half-width">
      <a class="text-info" (click)="onSelect(serie)">
        {{ serie.name }}
      </a>
    </td>
  </tr>
  </tbody>
</table>
<div class="p-a-md" *ngIf="!data?.length">
  <gp-message text="COMMON.no_chart_data" type="info"></gp-message>
</div>
